"use client";

import Link from "next/link";
import { env } from "~/env.mjs";
import Image from "next/image";
import { LuAsterisk } from "react-icons/lu";
import { If } from "~/components/v3/Conditional";
import { ButtonLink } from "~/components/v3/themed/Button";
import { cn } from "~/utils/fontsConfig";

type Community = {
    id: string;
    name: string | null;
    slug: string;
    image: string | null;
    description: string | null;
    memberCount?: number | null;
    eventsCount?: number | null;
};

const StaticFeaturedCommunities = ({
    communities,
}: {
    communities?: Community[];
}) => {
    return (
        <div className="flex flex-col">
            <div className="w-inherit">
                <div className="relative hidden overflow-hidden lg:block">
                    <div className="flex animate-scroll whitespace-nowrap hover:[animation-play-state:paused]">
                        <div className="flex shrink-0 gap-4 pl-4">
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "all-in",
                                )}
                                imgPath="/home/featured-communities/All-In@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "tim",
                                )}
                                imgPath="/home/featured-communities/Tim Ferris@2.png"
                                cardColor="#D1E350"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "utahtechweek",
                                )}
                                imgPath="/home/featured-communities/Utah Tech Week-comm@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "experiments",
                                )}
                                imgPath="/home/featured-communities/Experiments@2.png"
                                cardColor="#D1E350"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dontdie",
                                )}
                                imgPath="/home/featured-communities/Don't Die@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "bolt",
                                )}
                                imgPath="/home/featured-communities/Bolt@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dave-asprey",
                                )}
                                imgPath="/home/featured-communities/Dave Asprey@2.png"
                                cardColor="#C9E9E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "degods",
                                )}
                                imgPath="/home/featured-communities/DeGods@2.png"
                                cardColor="#99DB9D"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "solana",
                                )}
                                imgPath="/home/featured-communities/Solana@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "superteam",
                                )}
                                imgPath="/home/featured-communities/Superteam-comm@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "twist",
                                )}
                                imgPath="/home/featured-communities/FounderFridays@2.png"
                                cardColor="#C9E9E9"
                            />
                        </div>
                        <div
                            className="flex shrink-0 gap-4 pl-4"
                            aria-hidden="true"
                        >
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "all-in",
                                )}
                                imgPath="/home/featured-communities/All-In@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "tim",
                                )}
                                imgPath="/home/featured-communities/Tim Ferris@2.png"
                                cardColor="#D1E350"
                            />

                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "utahtechweek",
                                )}
                                imgPath="/home/featured-communities/Utah Tech Week-comm@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "experiments",
                                )}
                                imgPath="/home/featured-communities/Experiments@2.png"
                                cardColor="#D1E350"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dontdie",
                                )}
                                imgPath="/home/featured-communities/Don't Die@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "bolt",
                                )}
                                imgPath="/home/featured-communities/Bolt@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dave-asprey",
                                )}
                                imgPath="/home/featured-communities/Dave Asprey@2.png"
                                cardColor="#C9E9E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "degods",
                                )}
                                imgPath="/home/featured-communities/DeGods@2.png"
                                cardColor="#99DB9D"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "solana",
                                )}
                                imgPath="/home/featured-communities/Solana@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "superteam",
                                )}
                                imgPath="/home/featured-communities/Superteam-comm@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "twist",
                                )}
                                imgPath="/home/featured-communities/FounderFridays@2.png"
                                cardColor="#C9E9E9"
                            />
                        </div>
                        <div
                            className="flex shrink-0 gap-4 pl-4"
                            aria-hidden="true"
                        >
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "all-in",
                                )}
                                imgPath="/home/featured-communities/All-In@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "tim",
                                )}
                                imgPath="/home/featured-communities/Tim Ferris@2.png"
                                cardColor="#D1E350"
                            />

                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "utahtechweek",
                                )}
                                imgPath="/home/featured-communities/Utah Tech Week-comm@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "experiments",
                                )}
                                imgPath="/home/featured-communities/Experiments@2.png"
                                cardColor="#D1E350"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dontdie",
                                )}
                                imgPath="/home/featured-communities/Don't Die@2.png"
                                cardColor="#CEBDF1"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "bolt",
                                )}
                                imgPath="/home/featured-communities/Bolt@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "dave-asprey",
                                )}
                                imgPath="/home/featured-communities/Dave Asprey@2.png"
                                cardColor="#C9E9E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "degods",
                                )}
                                imgPath="/home/featured-communities/DeGods@2.png"
                                cardColor="#99DB9D"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "solana",
                                )}
                                imgPath="/home/featured-communities/Solana@2.png"
                                cardColor="#CDE9C9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "superteam",
                                )}
                                imgPath="/home/featured-communities/Superteam-comm@2.png"
                                cardColor="#F8F5E9"
                            />
                            <FeaturedCommunitiesCard
                                community={communities?.find(
                                    (e) => e.slug === "twist",
                                )}
                                imgPath="/home/featured-communities/FounderFridays@2.png"
                                cardColor="#C9E9E9"
                            />
                        </div>
                    </div>
                </div>
                <div className="relative lg:hidden">
                    <div className="small-scrollbar overflow-x-auto">
                        <div className="flex whitespace-nowrap pb-2 pl-4">
                            <div className="flex shrink-0 gap-4">
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "all-in",
                                    )}
                                    imgPath="/home/featured-communities/All-In@2.png"
                                    cardColor="#CEBDF1"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "tim",
                                    )}
                                    imgPath="/home/featured-communities/Tim Ferris@2.png"
                                    cardColor="#D1E350"
                                />

                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "utahtechweek",
                                    )}
                                    imgPath="/home/featured-communities/Utah Tech Week-comm@2.png"
                                    cardColor="#CDE9C9"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "experiments",
                                    )}
                                    imgPath="/home/featured-communities/Experiments@2.png"
                                    cardColor="#D1E350"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "dontdie",
                                    )}
                                    imgPath="/home/featured-communities/Don't Die@2.png"
                                    cardColor="#CEBDF1"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "bolt",
                                    )}
                                    imgPath="/home/featured-communities/Bolt@2.png"
                                    cardColor="#F8F5E9"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "dave-asprey",
                                    )}
                                    imgPath="/home/featured-communities/Dave Asprey@2.png"
                                    cardColor="#C9E9E9"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "degods",
                                    )}
                                    imgPath="/home/featured-communities/DeGods@2.png"
                                    cardColor="#99DB9D"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "solana",
                                    )}
                                    imgPath="/home/featured-communities/Solana@2.png"
                                    cardColor="#CDE9C9"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "superteam",
                                    )}
                                    imgPath="/home/featured-communities/Superteam-comm@2.png"
                                    cardColor="#F8F5E9"
                                />
                                <FeaturedCommunitiesCard
                                    community={communities?.find(
                                        (e) => e.slug === "twist",
                                    )}
                                    imgPath="/home/featured-communities/FounderFridays@2.png"
                                    cardColor="#C9E9E9"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaticFeaturedCommunities;

const FeaturedCommunitiesCard = ({
    community,
    imgPath,
    cardColor,
}: {
    community?: Community;
    imgPath: string;
    cardColor: string;
}) => {
    return (
        <div
            className={cn(
                "flex h-[532px] w-[310px] flex-col items-center justify-start gap-2 rounded-3xl p-5 text-black sm:w-[384px]",
            )}
            style={{ backgroundColor: cardColor }}
        >
            <div className="hidden h-[282px] w-[348px] sm:block">
                <Image
                    src={imgPath}
                    alt={community?.name ?? "community image"}
                    width={348}
                    height={282}
                    className="h-full w-full rounded-xl object-cover"
                />
            </div>
            <div className="block h-[282px] w-[280px] sm:hidden">
                <Image
                    src={imgPath}
                    alt={community?.name ?? "community image"}
                    width={368}
                    height={282}
                    className="h-full w-full rounded-xl object-cover"
                />
            </div>
            <div className="flex w-full items-center gap-2">
                <div className="relative h-[40px] w-[40px] shrink-0 items-center overflow-hidden rounded-full">
                    <Image
                        src={`${env.NEXT_PUBLIC_ASSETS_URL}/community/${community?.id}/${community?.image}`}
                        alt={community?.name ?? "community pfp"}
                        fill
                        className="h-full w-full rounded-xl object-cover"
                    />
                </div>
                <div className="flex flex-col gap-2 overflow-hidden">
                    <h3 className="truncate text-[24px] font-[500] leading-tight md:text-[24px]">
                        {community?.name}
                    </h3>
                </div>
            </div>
            <div className="flex w-full items-center justify-start gap-2 text-[16px] font-[500] text-v3-N550">
                <If condition={!!community?.memberCount}>
                    <div className="flex items-center gap-1">
                        <span>
                            {community?.memberCount?.toLocaleString("en-US")}
                        </span>
                        <span>members</span>
                    </div>
                </If>
                <If condition={!!community?.eventsCount}>
                    <div className="flex items-center gap-1">
                        <LuAsterisk className="h-4 w-4" />
                        <span>
                            {community?.eventsCount?.toLocaleString("en-US")}
                        </span>
                        <span>events</span>
                    </div>
                </If>
            </div>
            <div className="line-clamp-3 w-full text-[16px] font-[500] leading-[1.4] text-v3-N550">
                {community?.description}
            </div>
            <div className="mt-auto">
                <ButtonLink
                    href={`/${community?.slug}`}
                    target="_blank"
                    variant="secondary"
                >
                    Go to community
                </ButtonLink>
            </div>
        </div>
    );
};
